//Import Splide js
import Splide from '@splidejs/splide';
//import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

/*const options = {
  type: 'slide',
  perPage: 3,
  arrows: false,
  pagination: true,
  drag: true,

  gap: 80,
  trimSpace: false,
  padding: {
    right: '9rem',
  },
  mediaQuery: 'max',
  breakpoints: {
    1600: {
      perPage: 2,
    },
    768: {
      perPage: 1,
      gap: 20,
      padding: {
        right: '4rem',
      },
    },
  },
};*/
const arrowpath =
  'M29.44 18.59C30.23 19.37 30.23 20.64 29.44 21.42L17.44 33.42C16.66 34.2 15.39 34.2 14.61 33.42C13.83 32.64 13.83 31.37 14.61 30.59L25.2 20L14.62 9.41C13.84 8.63 13.84 7.36 14.62 6.58C15.4 5.8 16.67 5.8 17.45 6.58L29.45 18.58z';
const productOptions = {
  type: 'slide',
  autoWidth: true,
  perPage: 3,
  arrows: true,
  arrowPath: arrowpath,
  pagination: false,
  drag: true,
  gap: 80,
  padding: {
    right: '9rem',
  },
  mediaQuery: 'max',
  breakpoints: {
    768: {
      perPage: 3,
      gap: 20,
      padding: {
        right: '4rem',
      },
    },
    480: {
      perPage: 1,
      gap: 20,
      autoWidth: false,
      padding: {
        right: '0rem',
      },
    },
  },
};

const newsOptions = {
  type: 'slide',
  perPage: 3,
  arrows: true,
  arrowPath: arrowpath,
  pagination: false,
  drag: true,
  gap: 40,
  breakpoints: {
    1600: {
      perPage: 2,
    },
    768: {
      perPage: 1,
      gap: 20,
      padding: {
        right: '0rem',
      },
    },
  },
};

export default class SplideGallery {
  static showroom(target) {
    let splide = new Splide(target, productOptions);
    splide.mount();
  }
  static product(target) {
    let splide = new Splide(target, productOptions);
    splide.mount();
  }

  static news(target) {
    let splide = new Splide(target, newsOptions);
    splide.mount();
  }
}
